/*! Oruga v0.10.4 | MIT License | github.com/oruga-ui/oruga */
import { watch, getCurrentScope, onMounted, onScopeDispose } from "vue";
import { isObject } from "./helpers.mjs";
import { u as unrefElement } from "./unrefElement-6_1FNSAa.mjs";
function useEventListener(element, event, handler, options) {
  let cleanup;
  const register = () => {
    if (!element) return;
    const target = unrefElement(element);
    const optionsClone = isObject(options) ? { ...options } : options;
    setTimeout(() => {
      target.addEventListener(event, handler, optionsClone);
      cleanup = () => {
        target.removeEventListener(event, handler, optionsClone);
      };
    });
  };
  let stopWatch;
  if (typeof (options == null ? void 0 : options.trigger) !== "undefined") {
    stopWatch = watch(
      options.trigger,
      (value) => {
        if (value) register();
        else if (typeof cleanup === "function") cleanup();
      },
      { flush: "post" }
    );
  }
  if (options == null ? void 0 : options.immediate) register();
  else if (getCurrentScope()) {
    onMounted(() => {
      if (typeof (options == null ? void 0 : options.trigger) === "undefined" || options.trigger.value)
        register();
    });
  }
  const stop = () => {
    if (typeof stopWatch === "function") stopWatch();
    if (typeof cleanup === "function") cleanup();
  };
  if (getCurrentScope()) onScopeDispose(stop);
  return stop;
}
export {
  useEventListener as u
};
//# sourceMappingURL=useEventListener-Bx_q-JoG.mjs.map
